module.exports = __webpack_public_path__ + "img/iso1328-2-2020_fig02_total-radial-composite-deviation.20a0bd91.png";